import React from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    width: '100%',
    padding: [theme.marginBase * 3],
    maxWidth: theme.maxContentWidth.reduced,
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius.std,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  illustration: {
    width: '100%',
    height: '100%',
    maxHeight: 64,
    maxWidth: 64,
    marginBottom: theme.marginBase * 3,
  },
  title: {
    ...theme.fonts.h5,
    marginBottom: theme.marginBase,
  },
  description: {
    ...theme.fonts.caption,
  },
}));

interface Props {
  illustration: string;
  alt: string;
  title?: string;
  description: string;
  className?: string;
}

export const EmptyState = ({
  illustration,
  alt,
  title,
  description,
  className,
}: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classnames(classes.container, className)}>
      <img src={illustration} alt={alt} className={classes.illustration} />
      {title && <h1 className={classes.title}>{t(title)}</h1>}
      <h2 className={classes.description}>{t(description)}</h2>
    </div>
  );
};
